import React, { Component } from "react";
import '../styles/Events.css';
import EventsTable from './EventsTable';

export default class Events extends Component {
  render() {
    return (
      <div className="EventsTable-Wrapper">
        <EventsTable />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Events.js